import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,

  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },

  },
  actions: {
    loadAll: async ({ commit }, columnDefs = []) => {
      commit("setListLoading", true);
      commit("setImpactBusinessList", []);
      const response = await api.get(`impactBusiness/all`);

      let impactBusinessList = [];
      let keywordToBusinessID = {};
      response.data.forEach(business => {
        let businessData = business;
        business.buyerSelected = parseInt(business.buyerSelected);
        business.supplierSelected = parseInt(business.supplierSelected);
        impactBusinessList.push({ id: business.id, ...business });
        keywordToBusinessID[businessData.urlKeyword] = businessData.id;
      });
      commit("setList", impactBusinessList);

      commit("setListLoading", false);
    },
  },
  getters: {
    list: state => {
      return state.list;
    },
    listLoading: state => {
      return state.listLoading;
    },
  }
};
